package com.klantenstop.web.data.models.dto.requests

import kotlinx.serialization.Serializable

@Serializable
data class CreateTokenDto(
    val email: String,
    val password: String
)
